// src/components/Navbar.js
import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Navbar.css";
import logo from "../assets/images/logo.png";

function Navbar() {
  const { i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="main-header">
      <div className="logo-container">
        <Link to="/">
          <img src={logo} alt="Unborders Logo" className="navbar-logo" />
        </Link>
      </div>

      <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
        <NavLink to="/" className="nav-link" onClick={() => setMenuOpen(false)}>الرئيسية</NavLink>
        <NavLink to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>من نحن</NavLink>
        <NavLink to="/services" className="nav-link" onClick={() => setMenuOpen(false)}>الخدمات</NavLink>
        <NavLink to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>تواصل معنا</NavLink>

      </nav>

      {/* Hamburger */}
      <div className={`hamburger ${menuOpen ? "active" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
}

export default Navbar;
